export default function MentionsLegales() {
    return (
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 prose-japet" data-testid="mentions-page">
            <span className="overline">Informations légales</span>
            <h1 className="mt-4 font-serif text-4xl md:text-5xl font-light text-brand-ink">Mentions légales</h1>
            <h2>Éditeur du site</h2>
            <p>
                Le présent site est édité par <strong>Japet Agencement</strong>, société spécialisée dans la rénovation
                d'intérieurs haut de gamme à Paris et en Île-de-France.
            </p>
            <p>Email : contact@japet-agencement.fr</p>

            <h2>Hébergement</h2>
            <p>Le site est hébergé sur une infrastructure cloud sécurisée.</p>

            <h2>Propriété intellectuelle</h2>
            <p>
                L'ensemble des contenus présents sur ce site (textes, images, logos, vidéos) sont la propriété exclusive
                de Japet Agencement, sauf mention contraire. Toute reproduction est interdite sans autorisation.
            </p>

            <h2>Politique de confidentialité</h2>
            <p>
                Les informations transmises via le formulaire de devis sont utilisées exclusivement pour le traitement
                de votre demande. Aucune donnée n'est transmise à des tiers. Vous disposez d'un droit d'accès, de
                rectification et de suppression de vos données, à exercer par email.
            </p>
        </div>
    );
}
